import { render } from "./NavBar3.vue?vue&type=template&id=5567babf"
import script from "./NavBar3.vue?vue&type=script&lang=js"
export * from "./NavBar3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__